/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecondaryStylingDTO
 */
export interface SecondaryStylingDTO {
    /**
     * 
     * @type {boolean}
     * @memberof SecondaryStylingDTO
     */
    enabled?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecondaryStylingDTO
     */
    rules?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SecondaryStylingDTO
     */
    sampleMetrics?: Array<string>;
}

/**
 * Check if a given object implements the SecondaryStylingDTO interface.
 */
export function instanceOfSecondaryStylingDTO(value: object): value is SecondaryStylingDTO {
    return true;
}

export function SecondaryStylingDTOFromJSON(json: any): SecondaryStylingDTO {
    return SecondaryStylingDTOFromJSONTyped(json, false);
}

export function SecondaryStylingDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecondaryStylingDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'rules': json['rules'] == null ? undefined : json['rules'],
        'sampleMetrics': json['sampleMetrics'] == null ? undefined : json['sampleMetrics'],
    };
}

export function SecondaryStylingDTOToJSON(value?: SecondaryStylingDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'enabled': value['enabled'],
        'rules': value['rules'],
        'sampleMetrics': value['sampleMetrics'],
    };
}

